import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import Titulo from '../comum/Titulo';
import {
    getFinanceiroCaixa,
    getPerfisEmpresa,
    hasPerfil,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import determinarPaginaAtual from '../../actions/venda/determinarPaginaAtualVenda';
import limparFiltroEncomenda from '../../actions/encomenda/limparFiltroEncomenda';
import buscarEncomendasEmpresa from '../../actions/encomenda/buscarEncomendasEmpresa';
import buscarEncomendaItinerario from '../../actions/encomenda/buscarEncomendaItinerario';
import embarcarEncomenda from '../../actions/encomenda/embarcarEncomenda';
import desembarcarEncomenda from '../../actions/encomenda/desembarcarEncomenda';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import EncomendaBaixaEntrega from './EncomendaBaixaEntrega';
import ModalInformarEntregaEncomenda from './ModalInformarEntregaEncomenda';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import determinarPaginaAtualEncomenda from '../../actions/encomenda/determinarPaginaAtualEncomenda';
import { gerarHashForString } from '../../util/stringUtil';
import { withRouter } from 'react-router-dom';
import QueryString from 'qs';
import { showSuccessMsg } from '../../util/messagesUtil';

const ModalConfirmacaoEmbarqueDesembarque = ({ acao, encomenda, limpar }) => (

    <div className="modal fade" id="modalConfirmarEmbarqueDesembarqueEncomenda" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmarEmbarqueDesembarqueEncomenda" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    {encomenda && encomenda.dataHoraEmbarque ? <p>Confirmar o desembarque da encomenda ?</p>
                        : <p>Confirmar o embarque da encomenda ?</p>}
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal" onClick={() => limpar()}>Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => acao()}>Sim
                    </button>
                </div>
            </div>
        </div>
    </div>);

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col ml-md-1">Exibir detalhes</div>
            <div className="col ml-md-1">Embarque/<p>Desembarque</p></div>
            <div className="col ml-md-1">Nº Pedido</div>
            <div className="col ml-md-1">Vendedor</div>
            <div className="col ml-md-1">Descrição encomenda</div>
            <div className="col ml-md-1">Remetente</div>
            <div className="col ml-md-1">Data emissão</div>
            <div className="col ml-md-1">Status do pedido</div>
            <div className="col ml-md-1">Valor</div>
            <div className="col ml-md-1">Confirmar Entrega</div>
        </div>
    </div>
);

export class PainelGerenciarEncomendasItinerario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imagensInformarEntrega: [],
            encomendaSelecionada: null,
            itinerarioId: null,
            historicos: [],
            idPedido: null
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualEncomenda(1)
        this.props.limparFiltroEncomenda();
    }

    componentDidMount() {
        const parametros = QueryString.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.itinerario) {
            this.setState({itinerarioId: parametros.itinerario})
            this.buscarEncomendas(parametros.itinerario);
        }
    }

    buscarEncomendas(itinerario) {
        this.props.buscarEncomendaItinerario(itinerario);
    }

    buscarEncomendaItinerario() {
        const parametros = QueryString.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.itinerario) {
            this.props.buscarEncomendaItinerario(parametros.itinerario);
        }
    }

    componentDidUpdate(prevProps) {
        const parametros = QueryString.parse(this.props.history.location.search, { ignoreQueryPrefix: true });

        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            if (parametros.itinerario) {
                this.buscarEncomendas(parametros.itinerario);
            }
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtualEncomenda(1)
            }
        }
    }

    preencherModalInformarEntregaEncomenda(imagensInformarEntrega) {
        if (imagensInformarEntrega && imagensInformarEntrega.length > 0) {
            this.setState({ imagensInformarEntrega: this.mapearObjetoImagem(imagensInformarEntrega) })
        }
    }

    mapearObjetoImagem(imagens) {
        return imagens.map(it => {
            return {
                hash: gerarHashForString(`${it.nome}`),
                ...it
            }
        });
    }

    removerImagemInformarEntrega(arquivo) {
        const arquivos = [...this.state.imagensInformarEntrega];
        const array = arquivos.filter(it => it.hash != arquivo.hash);

        this.setState({ imagensInformarEntrega: array });
    }

    adicionarImagensInformarEntrega(arquivos) {
        this.setState({ imagensInformarEntrega: arquivos });
    }

    limparImagensInformarEntrega() {
        this.setState({ imagensInformarEntrega: [] });
    }

    selecionarHistoricos(historicos, idPedido) {
        this.setState({
            historicos,
            idPedido
        });
    }

    selecionarEncomendaEmbarqueDesembarque(encomenda) {
        this.setState({ encomendaSelecionada: encomenda })
    }

    limparEncomendaEmbarqueDesembarque() {
        this.setState({ encomendaSelecionada: null })
    }

    embarcarDesembarcar() {
        if (this.state.encomendaSelecionada.dataHoraEmbarque) {
            this.props.desembarcarEncomenda(this.props.empresaSelecionada.id, this.state.encomendaSelecionada.id).then(() => {
                showSuccessMsg('Desembarque de encomenda realizado com sucesso!');
                this.props.buscarEncomendaItinerario(this.state.itinerarioId, this.props.empresaSelecionada.id);
            })
        } else {
            this.props.embarcarEncomenda(this.props.empresaSelecionada.id, this.state.encomendaSelecionada.id).then(() => {
                showSuccessMsg('Embarque de encomenda realizado com sucesso!');
                this.props.buscarEncomendaItinerario(this.state.itinerarioId, this.props.empresaSelecionada.id);
            })
        }
    }

    exibirEncomendas() {
        return this.props.encomendas
            .map((encomenda, index) => <EncomendaBaixaEntrega
                key={index}
                encomenda={encomenda}
                selecionarEncomendaEmbarqueDesembarque={this.selecionarEncomendaEmbarqueDesembarque.bind(this)}
                selecionarHistoricos={this.selecionarHistoricos.bind(this)}
                alterarExibicao={this.alterarExibicao}
                preencherModalInformarEntregaEncomenda={this.preencherModalInformarEntregaEncomenda.bind(this)}
                indice={index}
            />)
    }

    exibirTabelaEncomendas() {
        if (this.props.encomendas && this.props.encomendas.length) {
            return (<div className='mt-4'>
                <CabecalhoTabela />
                <div className="lista-table">
                    {this.exibirEncomendas()}
                </div>
            </div>
            )
        }
        return <div>Nenhuma encomenda cadastrada</div>;
    }

    render() {
        if (this.props.empresaSelecionada.habilitadoEncomenda || hasPerfil(PERFIL_ADMIN)) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN, ...getPerfisEmpresa(this.props.empresaSelecionada.id), getFinanceiroCaixa(this.props.empresaSelecionada.id)]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    <div>
                        <div className="row internas">
                            <Titulo texto="Gerenciar encomendas do itinerário" urlRetorno="/menu-encomendas" />
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                    <li className="nav-item dropdown nome-empresa">
                                        <div className='col-md-6'>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                {this.exibirTabelaEncomendas()}
                            </div>
                        </div>

                    </div>
                    <ModalInformarEntregaEncomenda buscarEncomendas={this.buscarEncomendaItinerario.bind(this)}
                        arquivos={this.state.imagensInformarEntrega}
                        removerImagem={this.removerImagemInformarEntrega.bind(this)}
                        adicionarImagens={this.adicionarImagensInformarEntrega.bind(this)}
                        limparImagens={this.limparImagensInformarEntrega.bind(this)} />

                    <ModalConfirmacaoEmbarqueDesembarque
                        encomenda={this.state.encomendaSelecionada}
                        limpar={this.limparEncomendaEmbarqueDesembarque.bind(this)}
                        acao={this.embarcarDesembarcar.bind(this)} />
                </Autorizacao>
            )
        }
        return '';
    }
}


export const mapStateToProps = (state) => {
    return {
        encomendas: state.encomendas.encomendas,
        empresaSelecionada: state.empresaSelecionada,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosEncomenda,
        paginaAtual: state.paginaAtualEncomenda,
        registrosPorPagina: state.registrosPorPaginaEncomenda
    }
};


export default withRouter(connect(mapStateToProps,
    {
        embarcarEncomenda,
        desembarcarEncomenda,
        determinarPaginaAtual,
        limparFiltroEncomenda,
        buscarEncomendaItinerario,
        buscarEncomendasEmpresa,
        determinarPaginaAtualEncomenda
    })(PainelGerenciarEncomendasItinerario));
